import { render } from "./ResetPassword.vue?vue&type=template&id=bdfc89b0"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
script.render = render

export default script